<div class="wave-container">
  <div class="row hero-container">
    <div class="col-sm-12">
        <h1 class="hero-text text-shadow montserrat px-2">
          Une recherche rapide avec les derniers prix du marché
        </h1>
        <p class="mt-5 btn-wrapper">
            <a href="#search" class="btn btn-lg references-btn mt-3 search-btn">
              <span>
                Je trouve ma référence
                <mat-icon class="search-icon" aria-hidden="false" aria-label="search icon">search</mat-icon>
              </span>
            </a>
            <a routerLink="references" class="btn btn-lg references-btn mt-3 list-btn">
              <span>
                Je consulte les modèles
                <mat-icon class="search-icon" aria-hidden="false" aria-label="list icon">list</mat-icon>
              </span>
            </a>
        </p>
    </div>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#FFF" fill-opacity="1" d="M0,256L48,229.3C96,203,192,149,288,154.7C384,160,480,224,576,218.7C672,213,768,139,864,128C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
</div>

<div class="container-fluid m-0 p-0">
  <section class="sell-section">
    <div class="row mx-0">
      <div class="col-md-6 offset-md-3">
        <h2 id="purpose" class="main-title text-center mb-5">
          Vendez au bon prix, <br>
          achetez au meilleur
        </h2>

        <p class="main-text mt-4 px-3">
          Vous chinez un appareil photo argentique ou vous souhaiteriez vendre le votre mais vous ne savez pas
          si le prix est correct ? <br>Ici vous pouvez vous en faire une idée en recherchant votre modèle.
        </p>
      </div>
    </div>

    <div class="row mt-3 mx-0 pb-5">
      <div class="col-md-6 offset-md-3 col-sm-12 img-wrapper">
        <img src="assets/images/film-camera.jpg" class="img-fluid rounded mx-auto d-block" alt="film-camera">
        <div class="caption col-md-10 rounded p-3">
          <h3>Mieux négocier son prix</h3>
          <p class="main-text m-0">Les prix sont calculés périodiquement d'après les dernières offres et ventes réalisées.</p>
        </div>
        <div class="caption-small col-md-12 text-center rounded p-3">
          <h3>Mieux négocier son prix</h3>
          <p class="main-text m-0">Les prix sont calculés périodiquement d'après les dernières offres et ventes réalisées.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="search">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f3f4f5" fill-opacity="1" d="M0,320L80,304C160,288,320,256,480,208C640,160,800,96,960,96C1120,96,1280,160,1360,192L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
    <div class="search-wrapper px-3">
      <div class="col-md-6 offset-md-3">
        <h2 id="search" class="text-center main-title mb-5">
          J'estime un modèle 
        </h2>
      </div>
      <div class="col-md-6 offset-md-3">
        <app-search-model></app-search-model>
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f3f4f5" fill-opacity="1" d="M0,320L80,304C160,288,320,256,480,208C640,160,800,96,960,96C1120,96,1280,160,1360,192L1440,224L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path></svg>
  </section>

  <section class="reference-section mt-5 mb-5">
    <div class="row mx-0">
      <div class="col-md-6 offset-md-3 buy-section">
        <h2 id="partners" class="text-center main-title">
          Partenaires
        </h2>
      </div>
      <div class="row">
        <div class="col-md-6 offset-md-3 mt-5">
          <img src="assets/images/surlescocottes.png" alt="brand-name-1" class="img-responsive image-center">
        </div>
        <!--
        <div class="col-xs-12 col-md-4 mt-5">
          <img src="assets/images/surlescocottes.png" alt="brand-name-1" class="img-responsive image-center">
        </div>
        <div class="col-xs-12 col-md-4 mr-5 ml-5 mt-5">
          <img src="assets/images/surlescocottes.png" alt="brand-name-2" class="img-responsive image-center">
        </div>
        <div class="col-xs-12 col-md-4 mt-5">
          <img src="assets/images/surlescocottes.png" alt="brand-name-3" class="img-responsive image-center">
        </div>
        -->
      </div>
    </div>
  </section>
</div>
